/**
 * Read-only summary of a saved free-text "Comment" on a criterion.
 *
 * Renders the reviewer's note inside the shared feedback card, with an "Edit"
 * affordance that reopens the feedback form on the Comment kind.
 * @module IncorrectCommentSummary
 */
import React from "react";
import { FeedbackSummaryCard } from "./FeedbackSummaryCard";

/** Props for {@link IncorrectCommentSummary}. */
interface IncorrectCommentSummaryProps {
  /** The reviewer's free-text note. */
  comment: string;
  /** Invoked when the reviewer clicks "Edit" to reopen the feedback form. */
  onEdit: () => void;
}

/**
 * Renders the saved reviewer-comment summary card.
 *
 * @param props - The comment text and the edit handler
 * @returns The rendered summary, or null when there is no comment text
 */
export const IncorrectCommentSummary: React.FC<
  IncorrectCommentSummaryProps
> = ({ comment, onEdit }) => {
  if (!comment.trim().length) return null;

  return (
    <FeedbackSummaryCard title="Comment" onEdit={onEdit}>
      <span className="whitespace-pre-wrap text-[0.6875rem] font-normal leading-[1.03125rem] text-[#0F0F0F]">
        {comment}
      </span>
    </FeedbackSummaryCard>
  );
};
